import { MASK_PLACEHOLDER_PREVIEW_IMG_SRC } from 'components/VisualStudioPlayground/Shapes/MaskShape/constants'
import { useId } from 'react'

export const ArrowUp = () => {
  const imageId = useId()
  const patternId = useId()

  return (
    <svg width="74" viewBox="0 0 74 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M73.2717 33.6131L37.0873 0.0640011L0.903992 33.6131H17.5936V79.9283H56.5811V33.6131H73.2717Z"
        fill={`url(#${patternId})`}
        fillOpacity="0.6"
      />
      <defs>
        <pattern id={patternId} patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref={`#${imageId}`} transform="matrix(0.0110972 0 0 0.0111111 0.000626541 0)" />
        </pattern>
        <image id={imageId} width="90" height="90" xlinkHref={MASK_PLACEHOLDER_PREVIEW_IMG_SRC} />
      </defs>
    </svg>
  )
}
